import * as caretakerManager from '$domain/model/caretaker/caretaker.manager'
import * as customerManager from '$domain/model/customer/customer.manager'
import { tagManager } from '$infrastructure/tagManager/tagManager'

export const registerCaretaker = async (name: string, email: string, password: string) => {
  await caretakerManager.registerCaretaker(name, email, password)
  tagManager.push({
    event: 'signup',
    userType: 'Cuidador',
  })
}

export const registerGuestCustomer = (email: string, password: string) => {
  customerManager.registerGuestCustomer(email, password)

  tagManager.push({
    event: 'signup',
    userType: 'Particular',
  })
}

export const registerCustomer = async (name: string, phone: string, email: string, password: string) => {
  try {
    await customerManager.registerCustomer(name, phone, email, password)
    tagManager.push({
      event: 'signup',
      userType: 'Particular',
    })
  } catch (error) {
    if (error.data.MENSAJE_ERROR[0] === 'EMAIL_IN_USE_BY_GUEST') {
      await registerGuestCustomer(email, password)
    } else {
      throw error
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/user/registration/registration.service.ts